<itfg-nssi-report [client]="client" [creditId]="null"></itfg-nssi-report>
